export const defaultFiltererExperience = (item, filter) => {
  let checkCategoria = true
  let checkDurata = true

  // filter by categoria
  if (filter.categoria) {
    const categoria = item.codiceCategoria.name
    const filterCategoria = filter.categoria
    checkCategoria = categoria.indexOf(filterCategoria) >= 0
  }

  // filter by durata
  if (filter.durata) {
    const durata = item.days.length
    checkDurata = durata >= filter.durata[0] && durata <= filter.durata[1]
  }

  return checkCategoria && checkDurata
}

export const defaultSorterExperience = (a, b, order) => {
  if (order.categoria) {
    const delta = a.codiceCategoria.name.localeCompare(b.codiceCategoria.name)
    return order.categoria === 'up' ? delta : -1 * delta
  }
  if (order.durata) {
    const delta = a.days.length - b.days.length
    return order.durata === 'up' ? delta : -1 * delta
  }
}



// WEBPACK FOOTER //
// ./src/front/utils/experienceUtils.js